"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  overflow: hidden;\n  width: 400px;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("../styledTypes");

var NotificationsHost_1 = require("./NotificationsHost");

function Notification(_ref) {
  var children = _ref.children,
      id = _ref.id;

  var _ref2 = (0, NotificationsHost_1.useNotificationsContext)(true),
      registerNotification = _ref2.registerNotification,
      removeNotification = _ref2.removeNotification;

  react_1.default.useEffect(function () {
    registerNotification(id, react_1.default.createElement(Container, {
      children: children
    }));
  }, [children]);
  react_1.default.useEffect(function () {
    return function () {
      removeNotification(id);
    };
  }, []);
  return null;
}

exports.Notification = Notification;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@shadow-medium'];
});